import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import GuestAudienceReport from './GuestAudienceReport';
import HomeownerAudienceReport from './HomeownerAudienceReport';

export const MarketingModule: React.FC = () => (
  <>
    <Route exact path={APP_ROUTES.MARKETING_MODULE.FULL_PATH}>
      <Redirect
        to={(APP_ROUTES.MARKETING_MODULE.CHILDREN as RouteConfig).GUEST_AUDIENCE.FULL_PATH}
      />
    </Route>
    <Route
      exact
      path={(APP_ROUTES.MARKETING_MODULE.CHILDREN as RouteConfig).GUEST_AUDIENCE.FULL_PATH}
      component={GuestAudienceReport}
    />
    <Route
      exact
      path={(APP_ROUTES.MARKETING_MODULE.CHILDREN as RouteConfig).HOMEOWNER_AUDIENCE.FULL_PATH}
      component={HomeownerAudienceReport}
    />
  </>
);
